import React, { useEffect, useState } from "react";
import useInbox from "hooks/useInbox.ts";
import TabBarMenu from "./TabBarMenu.tsx";
import NoMailSelectedSplitMenu from "./NoMailSelectedSplitMenu.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import { useUser } from "contexts/userContext/userContext.js";
import TabBarContent from "./TabBarContent.tsx";
import useInboxQueryParams from "hooks/useInboxQueryParams.ts";

const SplitPanelComponent = () => {
  const {
    getSplitView,
    setSplitView,
    getSelectedMail,
    setSelectedMail,
    setHoveredMail,
    getHoveredMail,
    getIsFetching,
  } = useInbox();
  const { isLoggedIn } = useUser();
  const [selectedTab, setSelectedTab] = useState("tab-info");
  const [isMounted, setIsMounted] = useState(false);
  const { getQueryParam } = useInboxQueryParams();

  // clear selected mail data if split panel collapsed
  useEffect(() => {
    if (!getSplitView()) {
      setSelectedMail(null);
      setHoveredMail(null);
    }
  }, [getSplitView()]);

  // expand split panel only when page was loaded for the first time
  useEffect(() => {
    // if mail's data isn't fetching
    // and component was mounted for the first time
    // and user is logged in,
    // expand split panel
    if (
      !getIsFetching() &&
      !isMounted &&
      isLoggedIn() &&
      getQueryParam("t") !== "picker"
    ) {
      setSplitView(true);
      setIsMounted(true);
    }
  }, [getIsFetching(), isMounted, isLoggedIn(), getQueryParam("t")]);

  return (
    <AnimationContainer
      animationOn={
        getSplitView() && isLoggedIn() && !getIsFetching() && isMounted
      }
      animationClassName="side-bar-animation"
    >
      <div className="split-info-container">
        {getSelectedMail() || getHoveredMail() ? (
          <>
            <TabBarMenu
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />
            <TabBarContent selectedTab={selectedTab} />
          </>
        ) : (
          <div className="no-mail-selected-wrapper">
            <NoMailSelectedSplitMenu />
          </div>
        )}
      </div>
    </AnimationContainer>
  );
};

export default SplitPanelComponent;
